import { Action, Reducer } from 'redux';
import { LOADING, ACCIDENTSLOADED, ACCIDENTSSTATLOADED, BRANCHESLOADED, ACCIDENTSTRANSFERRED, ACCIDENTSREPORTLOADED, CLAIMSLISTSLOADED, MODELSLOADED, SUBMODELSLOADED, SUBMODELSSTYLEANDBODYLOADED, GARAGESLOADED, VEHICLEADDEDTOACCIDENT , USERSLOADED, PARTYADDEDTOACCIDENT, PATIENTSADDEDTOACCIDENT, ACCIDENTREPORTLOADED, CLAIMSBYLICENSERELOADED, INVESTIGATIONREPORTADDED} from './accidents.actions';



import { initialState } from './accidents.state';

export const AccidentsReducer: Reducer<any, Action> = (state = initialState, action: any) => {
    let newState = state;
    switch (action.type) {
        case LOADING: newState = { ...newState, loading: true };
            break;
        case ACCIDENTSLOADED: newState = { ...newState, loading: false, accidents: action.payload };
            break;
        case ACCIDENTSSTATLOADED: newState = { ...newState, loading: false, accidentsStat: action.payload };
            break;
        case BRANCHESLOADED: newState = { ...newState, loading: false, branches: action.payload };
            break;
        case ACCIDENTSTRANSFERRED: newState = { ...newState, loading: false, transferResult: action.payload };
            break;
        case ACCIDENTSREPORTLOADED: newState = { ...newState, loading: false, report: action.payload, accident: action.payload };
            break;
        case CLAIMSLISTSLOADED: newState = { ...newState, loading: false, claimsList: action.payload };
            break;
        case MODELSLOADED: newState = { ...newState, loading: false, modelsList: action.payload };
            break;
        case SUBMODELSLOADED: newState = { ...newState, loading: false, subModelsList: action.payload };
            break;
        case SUBMODELSSTYLEANDBODYLOADED: newState = { ...newState, loading: false, subModelsStyleAndBody: action.payload };
            break;
        default:
            break;
        case GARAGESLOADED: newState = { ...newState, loading: false, garages: action.payload };
            break;
        case VEHICLEADDEDTOACCIDENT: newState = { ...newState, loading: false, vehicleAdded: action.payload, accident: action.payload };
            break;
        case USERSLOADED: newState = { ...newState, loading: false, usersList: action.payload };
            break;
        case PARTYADDEDTOACCIDENT: newState = { ...newState, loading: false, partyAdded: action.payload };
            break;
        case PATIENTSADDEDTOACCIDENT: newState = { ...newState, loading: false, patientsAdded: action.payload };
            break;
        case ACCIDENTREPORTLOADED: newState = { ...newState, loading: false, accidentReport: action.payload };
            break;
        case CLAIMSBYLICENSERELOADED: newState = { ...newState, loading: false, claimsByLicense: action.payload };
             break;
        case INVESTIGATIONREPORTADDED: newState = { ...newState, loading: false, investigationReport: action.payload };
             break;
    }

    return newState;
};
